import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  // Same-origin tunnel (CIR-2026-359): route envelopes through the first-party
  // `/monitoring` endpoint served by the Cloudflare domain-proxy Worker, instead of
  // POSTing cross-origin to `*.ingest.de.sentry.io`. This prevents the ingest POSTs
  // being aborted (ERR_ABORTED) by content/privacy blockers that match Sentry hosts
  // by name, and keeps the request inside CSP `connect-src 'self'`.
  tunnel: "/monitoring",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.1,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
